
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ImageWithBorder extends Vue {
  @Prop({ required: true })
  src: string

  @Prop({ required: true })
  imageClass: string

  @Prop({ default: 'div' })
  tag: string

  @Prop({ default: false })
  active: boolean

  @Prop({ default: undefined })
  height: number | undefined

  @Prop({ default: undefined })
  width: number | undefined

  @Prop({ default: false })
  lazy: boolean

  get _class() {
    return {
      active: this.active,
    }
  }

  get loading(): 'lazy' | 'eager' {
    return this.lazy ? 'lazy' : 'eager'
  }
}
